import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../util/Auth";
import "./AccessDenied.css";

export default function AccessDenied() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const directusUrl = process.env.REACT_APP_DIRECTUS_URL;
  const loginRedirectUrl =
    process.env.REACT_APP_LOGIN_REDIRECT_URL || `${window.location.origin}/login`;
  const currentRole =
    user?.roles?.length
      ? user.roles.join(", ")
      : user?.role || "sem role atribuido";

  return (
    <div className="access-denied-page">
      <div className="access-denied-container">
        <h1 className="access-denied-title">{t("pages.accessDenied.title")}</h1>
        <p className="access-denied-message">
          {t("pages.accessDenied.message")}
        </p>
        <p className="access-denied-submessage">
          {t("pages.accessDenied.submessage")}
        </p>
        <p className="access-denied-role">
          {t("pages.accessDenied.currentRole", {
            role: currentRole,
            defaultValue: "Seu perfil atual: {{role}}"
          })}
        </p>
        <a
          href={`${directusUrl}/auth/login/PV?redirect=${encodeURIComponent(loginRedirectUrl)}`}
          className="access-denied-button"
        >
          {t("pages.accessDenied.voltarLogin")}
        </a>
      </div>
    </div>
  );
}

